import { asyncRequest } from "helpers";

const params = new URLSearchParams(window.location.search);

if (params.get("store")) {
  const body = {
    attributes: {
      _store: params.get("store"),
    },
  };

  const options = {
    ...WYATT.config.fetch.post,
    ...{ body: JSON.stringify(body) },
  };

  asyncRequest(WYATT.routes.cart_update_url, options);
}
